import { EventEmitter } from '@angular/core';
import { BusinesLogicService } from '../../services/business-logic.service';
import { UtilsService } from '../../services/utils.service';
import { DataService } from '../../services/data.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
var AtypesComponent = (function () {
    function AtypesComponent(_blogic, _data, _utils) {
        this._blogic = _blogic;
        this._data = _data;
        this._utils = _utils;
        this.listChanged = new EventEmitter();
        this.buttonMode = false;
        this.isAttentionTurn = false;
        this.destroy$ = new Subject();
        this.turn = false;
        this.search = '';
        this.listFilter = { name: '' };
        this.atypes = (this._data.configuration["closeOnlyQueueKind"])
            ? (this._data.turn && this._data.turn["queue_id"]) ? this.getFilterKind(this._data.turn["queue_id"]) : this._data.session["atypes"]
            : this._data.session["atypes"];
    }
    AtypesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._updateTurn(this._data.turn);
        this._data.turnUpdate
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._updateTurn(response);
        });
        if (localStorage.getItem("searchkind") != null) {
            this.search = localStorage.getItem("searchkind");
            this.searchFilter();
        }
    };
    AtypesComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    AtypesComponent.prototype.getFilterKind = function (id) {
        return this._data.session["atypes"].filter(function (x) { return x.queue_id == id; });
    };
    /* Close current turn */
    AtypesComponent.prototype.close = function (id) {
        var _this = this;
        var params = {
            desk_id: (this.selectedTurn && this.isAttentionTurn) ? this.selectedTurn["desk_id"] : this._data.session["desk"],
            status: "I",
            turn_id: (this.selectedTurn && this.isAttentionTurn) ? this.selectedTurn["id"] : this._data.turn["id"],
            ticket: (this.selectedTurn && this.isAttentionTurn) ? this.selectedTurn["num"] : this._data.turn["num"],
            label: (this.selectedTurn && this.isAttentionTurn) ? this.selectedTurn["label"] : this._data.turn["label"],
            queue_id: (this.selectedTurn && this.isAttentionTurn) ? this.selectedTurn["queue_id"] : this._data.turn["queue_id"],
            session_id: this._data.session["id"],
            kind_id: id,
            deskuser: this._data.session["username"],
            deskoperator: this._data.session["operator"]
        };
        this._blogic.deskNotify(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            if (_this._data.session["wmode"] == 'A') {
                _this.listChanged.emit(true);
                _this._call();
            }
            else {
                _this._data.closeTurn();
            }
        });
    };
    AtypesComponent.prototype.getPrekindId = function () {
        if (this.selectedTurn && this.isAttentionTurn) {
            return this.selectedTurn['prekind_id'];
        }
        return this._data.turn['prekind_id'];
    };
    /* When the turn information change */
    AtypesComponent.prototype._updateTurn = function (turn) {
        if (this._data.turnIsActive()) {
            this.turn = true;
            this.category = this._data.turn['category'];
        }
        else {
            this.turn = false;
        }
    };
    AtypesComponent.prototype.searchFilter = function () {
        this.listFilter = {
            $or: [{ name: this.search }]
        };
        localStorage.setItem("searchkind", this.search);
    };
    AtypesComponent.prototype.removeSearch = function () {
        this.search = "";
        localStorage.removeItem("searchkind");
        this.searchFilter();
    };
    /* Call a new turn */
    AtypesComponent.prototype._call = function () {
        var _this = this;
        var params = {
            desk_id: this._data.session["desk"],
            status: "A",
            deskuser: this._data.session["username"],
            deskoperator: this._data.session["operator"],
        };
        this._blogic.deskNotify(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this.listChanged.emit(true);
            if (response == null) {
                _this._data.closeTurn();
            }
            else {
                _this._data.turn = response;
            }
        });
    };
    AtypesComponent.prototype.orderedAtypes = function () {
        return this.atypes.sort(function (a, b) {
            return a.place - b.place;
        });
    };
    return AtypesComponent;
}());
export { AtypesComponent };
